// import React from "react";
// import { Navigate, useLocation } from "react-router-dom";
// import authService from "../services/authService";

// const ProtectedRoute = ({ children, allowedRoles }) => {
//   const location = useLocation();
//   const token = authService.getToken();
//   const user = authService.getCurrentUser();

//   if (!token || !user) {
//     // Redirect to login if user is not authenticated
//     return <Navigate to="/login" state={{ from: location }} replace />;
//   }

//   if (allowedRoles && allowedRoles.length > 0 && !allowedRoles.includes(user.role)) {
//     // Redirect to dashboard if user role does not have permission
//     return <Navigate to="/dashboard" replace />;
//   }

//   return children;
// };

// export default ProtectedRoute;







import React from "react";
import {
  Navigate,
  useLocation,
} from "react-router-dom";

import authService from "../services/authService";

const ProtectedRoute = ({
  children,
  allowedRoles,
}) => {
  const location = useLocation();

  // ============================================================
  // STAFF AUTH
  // ============================================================

  const staffToken = authService.getToken();
  const staffUser = authService.getCurrentUser();

  const isStaffLoggedIn =
    Boolean(staffToken) &&
    Boolean(staffUser);

  // ============================================================
  // COMPUTER AUTH
  // ============================================================

  const computerToken =
    sessionStorage.getItem("computer_token") ||
    localStorage.getItem("computer_token");

  let computer = null;

  try {
    const storedComputer =
      sessionStorage.getItem("computer") ||
      localStorage.getItem("computer");

    if (storedComputer) {
      computer = JSON.parse(storedComputer);
    }
  } catch (error) {
    console.error(
      "Invalid Computer Session:",
      error
    );

    sessionStorage.removeItem(
      "computer_token"
    );

    sessionStorage.removeItem(
      "computer"
    );

    localStorage.removeItem(
      "computer_token"
    );

    localStorage.removeItem(
      "computer"
    );
  }

  const isComputerLoggedIn =
    Boolean(computerToken) &&
    Boolean(computer);

  // ============================================================
  // DETERMINE CURRENT ROLE
  // ============================================================

  const pathname = location.pathname;
  const isComputerRoute =
    pathname.startsWith("/computer-dashboard") ||
    pathname.startsWith("/fun-roulette") ||
    pathname.startsWith("/computer-history");

  let currentRole = null;

  if (isComputerRoute) {
    if (isComputerLoggedIn) {
      currentRole = "COMPUTER";
    } else if (isStaffLoggedIn) {
      currentRole = staffUser.role;
    }
  } else {
    if (isStaffLoggedIn) {
      currentRole = staffUser.role;
    } else if (isComputerLoggedIn) {
      currentRole = "COMPUTER";
    }
  }

  // ============================================================
  // NOT LOGGED IN
  // ============================================================

  if (!currentRole) {
    return (
      <Navigate
        to={isComputerRoute ? "/computer-login" : "/login"}
        state={{
          from: location,
        }}
        replace
      />
    );
  }

  // ============================================================
  // ROLE CHECK
  // ============================================================

  if (
    allowedRoles &&
    allowedRoles.length > 0 &&
    !allowedRoles.includes(currentRole)
  ) {
    // Computer should go to Computer Dashboard
    if (currentRole === "COMPUTER") {
      return (
        <Navigate
          to="/computer-dashboard"
          replace
        />
      );
    }

    // Staff goes to normal Dashboard
    return (
      <Navigate
        to="/dashboard"
        replace
      />
    );
  }

  // ============================================================
  // ACCESS GRANTED
  // ============================================================

  return children;
};

export default ProtectedRoute;
